/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GetFursSettings200,
  UpdateFursSettings200,
  UpdateFursSettingsBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve FURS fiscalization settings for the entity, including certificate status and configuration
 * @summary Get FURS settings
 */
export type getFursSettingsResponse200 = {
  data: GetFursSettings200
  status: 200
}

export type getFursSettingsResponse400 = {
  data: Error
  status: 400
}

export type getFursSettingsResponse401 = {
  data: Error
  status: 401
}

export type getFursSettingsResponse403 = {
  data: Error
  status: 403
}

export type getFursSettingsResponse404 = {
  data: Error
  status: 404
}

export type getFursSettingsResponse500 = {
  data: Error
  status: 500
}

export type getFursSettingsResponseSuccess = (getFursSettingsResponse200) & {
  headers: Headers;
};
export type getFursSettingsResponseError = (getFursSettingsResponse400 | getFursSettingsResponse401 | getFursSettingsResponse403 | getFursSettingsResponse404 | getFursSettingsResponse500) & {
  headers: Headers;
};

export type getFursSettingsResponse = (getFursSettingsResponseSuccess | getFursSettingsResponseError)

export const getGetFursSettingsUrl = () => {


  

  return `/fiscalization/furs/settings`
}

export const getFursSettings = async ( options?: RequestInit): Promise<getFursSettingsResponse> => {
  
  return customFetch<getFursSettingsResponse>(getGetFursSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update FURS fiscalization settings for the entity. Certificate must be uploaded separately via POST /fiscalization/furs/settings/certificate
 * @summary Update FURS settings
 */
export type updateFursSettingsResponse200 = {
  data: UpdateFursSettings200
  status: 200
}

export type updateFursSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateFursSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateFursSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateFursSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateFursSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateFursSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateFursSettingsResponseSuccess = (updateFursSettingsResponse200) & {
  headers: Headers;
};
export type updateFursSettingsResponseError = (updateFursSettingsResponse400 | updateFursSettingsResponse401 | updateFursSettingsResponse403 | updateFursSettingsResponse404 | updateFursSettingsResponse422 | updateFursSettingsResponse500) & {
  headers: Headers;
};

export type updateFursSettingsResponse = (updateFursSettingsResponseSuccess | updateFursSettingsResponseError)

export const getUpdateFursSettingsUrl = () => {


  

  return `/fiscalization/furs/settings`
}

export const updateFursSettings = async (updateFursSettingsBody: UpdateFursSettingsBody, options?: RequestInit): Promise<updateFursSettingsResponse> => {
  
  return customFetch<updateFursSettingsResponse>(getUpdateFursSettingsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateFursSettingsBody,)
  }
);}
  

